import { render, staticRenderFns } from "./vipConfirm.vue?vue&type=template&id=52109ad1&"
import script from "./vipConfirm.vue?vue&type=script&lang=js&"
export * from "./vipConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52109ad1')) {
      api.createRecord('52109ad1', component.options)
    } else {
      api.reload('52109ad1', component.options)
    }
    module.hot.accept("./vipConfirm.vue?vue&type=template&id=52109ad1&", function () {
      api.rerender('52109ad1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/vip/vipConfirm.vue"
export default component.exports